<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="8">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.tipos"
                    :validations="validations.tipo"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.tipoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 255,
                },
                tipo: {
                    required: true,
                }
            }
        },
    },
    created() {

        this.repositories = {
            classificacaoRisco: this.getConectaSusRepository('prontoAtendimento.classificacaoRisco')
        }

        this.load()
    },
    data: () => ({
        model: {},
        form: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.classificacaoRisco.edit(this.id)
                : this.repositories.classificacaoRisco.create()

            request
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.classificacaoRisco.update(this.id, this.prepareData())
                        : this.repositories.classificacaoRisco.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        id: { type: Number }
    },
}
</script>